import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Divider,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Pagination as MuiPagination,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { LiveCommentDetailDialog } from "./LiveCommentDetailDialog";


function TabletCard({ r, onSelect }) {
    return (
        <Card variant="outlined">
            <CardContent sx={{ "&:last-child": { pb: 2 } }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Chip size="small" label={r.reason || "Sin razón"} />
                    <Typography variant="caption" color="text.secondary">
                        #{r.id}
                    </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary" mb={1}>
                    {r.createdAt ? new Date(r.createdAt).toLocaleString("es-AR") : "-"}
                </Typography>

                <Box display="flex" gap={3} mb={1}>
                    <Box>
                        <Typography variant="caption" color="text.secondary">Reportó</Typography>
                        <Typography variant="body2" fontWeight={600}>
                            {r.reporter?.name} {r.reporter?.lastname}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">{r.reporter?.email}</Typography>
                    </Box>

                    <Box>
                        <Typography variant="caption" color="text.secondary">Autor</Typography>
                        <Typography variant="body2" fontWeight={600}>
                            {r.comment?.author?.name} {r.comment?.author?.lastname}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">{r.comment?.author?.email}</Typography>
                    </Box>
                </Box>

                <Typography variant="caption" color="text.secondary">Comentario</Typography>
                <Typography variant="body2" mb={1}>{r.comment?.comment}</Typography>

                <Typography variant="caption" color="text.secondary">Live</Typography>
                <Typography variant="body2" mb={1.5}>
                    {r.comment?.live?.title ?? `Live #${r.comment?.livesId}`}
                </Typography>

                <Button size="small" variant="outlined" fullWidth onClick={() => onSelect(r)}>
                    Ver detalle
                </Button>
            </CardContent>
        </Card>
    );
}


export function LiveCommentsTab({live}) {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

    return (
        <>
            {live?.error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {live?.error}
                </Alert>
            )}

            <Paper variant="outlined" sx={{ overflow: "hidden" }}>
                {live?.loading ? (
                    <Box p={3} display="flex" alignItems="center" gap={2}>
                        <CircularProgress size={22} />
                        <Typography>Cargando reportes…</Typography>
                    </Box>
                ) : live?.rows?.length === 0 ? (
                    <Box p={3}>
                        <Typography fontWeight={600}>Sin reportes</Typography>
                    </Box>
                ) : isTablet ? (
                    <>
                        <Stack spacing={1.5} p={2}>
                            {live?.rows?.map((r) => (
                                <TabletCard key={r.id} r={r} onSelect={live.setSelected} />
                            ))}
                        </Stack>

                        <Divider />

                        <Box p={2} display="flex" justifyContent="center" alignItems="center" gap={2}>
                            <Typography variant="body2" color="text.secondary">
                                Página {live.page} de {live.totalPages}
                            </Typography>

                            <MuiPagination
                                size="small"
                                page={live.page}
                                count={live.totalPages}
                                onChange={(_, p) => live.setPage(p)}
                            />
                        </Box>
                    </>
                ) : (
                    <>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Razón</TableCell>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Reportó</TableCell>
                                        <TableCell>Comentario</TableCell>
                                        <TableCell>Autor</TableCell>
                                        <TableCell>Live</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {live?.rows?.map((r) => (
                                        // console.log(r) &&
                                        <TableRow key={r.id} hover>
                                            <TableCell>{r.id}</TableCell>

                                            <TableCell>
                                                {r.reason ? <Chip size="small" label={r.reason} /> : "-"}
                                            </TableCell>

                                            <TableCell>
                                                {r.createdAt ? new Date(r.createdAt).toLocaleString("es-AR") : "-"}
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant="body2" fontWeight={600}>
                                                    {r.reporter?.name} {r.reporter?.lastname}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {r.reporter?.email}
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant="body2" noWrap sx={{ maxWidth: 260 }}>
                                                    {r.comment?.comment}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    #{r.comment?.id}
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant="body2" fontWeight={600}>
                                                    {r.comment?.author?.name} {r.comment?.author?.lastname}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {r.comment?.author?.email}
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant="body2" noWrap sx={{ maxWidth: 260 }}>
                                                    {r.comment?.live?.title ?? `Live #${r.comment?.livesId}`}
                                                </Typography>
                                            </TableCell>

                                            <TableCell align="right">
                                                <Button size="small" onClick={() => live.setSelected(r)}>
                                                    Ver detalle
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Divider />

                        <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="body2" color="text.secondary">
                                Página {live.page} de {live.totalPages}
                            </Typography>

                            <MuiPagination
                                page={live.page}
                                count={live.totalPages}
                                onChange={(_, p) => live.setPage(p)}
                            />
                        </Box>
                    </>
                )}
            </Paper>

            <LiveCommentDetailDialog
                open={Boolean(live.selected)}
                onClose={() => live.setSelected(null)}
                payload={live.selected}
            />
        </>
    );
}
